import { useQuery } from "@tanstack/react-query";
import { CampaignService } from "../services/BillingBrand.service";
import { ToastService } from "@shared/lib/services";
import { useEffect } from "react";
import { BackednResponse } from "@shared/lib/types";
import { IBrandBilling } from "@shared/lib/types/brandBilling";
import { BILLING_BRAND_DETAILS_QUERY_KEY } from "../constants";

export function useGetBrandBillingById(billingId: string) {
  const { data, isLoading, isError, error } = useQuery<
    BackednResponse<IBrandBilling>
  >({
    queryKey: BILLING_BRAND_DETAILS_QUERY_KEY(billingId),
    queryFn: () => CampaignService.getBrandBillingById(billingId),
    enabled: !!billingId,
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    brandBilling: data?.data,
    isError,
    isFetching: isLoading,
  };
}
